import Form, { UiSchema } from 'react-jsonschema-form-semanticui'
import * as React from 'react'
import { toast } from 'react-toastify'
import { adminService } from '../../../../../services'
import { JSONSchema6 } from 'json-schema'
import 'bootstrap/dist/css/bootstrap.min.css'
import { Button, Grid, Segment } from 'semantic-ui-react'
import { AdminInfo } from './AdminInfo'

type AdminState = {
  loading: boolean,
  adminSetting?: IAdminSetting
}

type AdminSettingProps = {
  loggedIn: boolean
  userInfo?: IUser
}

const adminSettingJSONSchema: JSONSchema6 = {
  'title': 'EZ Admin Setting',
  'type': 'object',
  'required': [],
  'properties': {
    'rollWebCookie': {
      'type': 'string',
      'title': 'Cookie of 5etop web'
    },
    'rollPhoneCookie': {
      'type': 'string',
      'title': 'Cookie of 5etop app'
    },
    'emailPhone': {
      'type': 'string',
      'title': 'Email of 5etop app'
    },
    'passwordPhone': {
      'type': 'string',
      'title': 'Password of 5etop app'
    },
    'requestTimeoutMinute': {
      'type': 'number',
      'title': 'Roll request timeout (minute)'
    },
    'rateMilestones': {
      'title': 'Roll Rate Milestones',
      'type': 'array',
      'items': {
        'type': 'number'
      }
    },
    'rateDetails': {
      'title': 'Roll Rate Details',
      'type': 'array',
      'items': {
        'type': 'number'
      }
    },
    'rateMilestonesCs': {
      'title': 'Roll Rate Milestones for CS item',
      'type': 'array',
      'items': {
        'type': 'number'
      }
    },
    'rateDetailsCs': {
      'title': 'Roll Rate Details for CS item',
      'type': 'array',
      'items': {
        'type': 'number'
      }
    },
    'rateCardKey' : {
      'title': 'Rate card key 24h',
      'type': 'number'
    },
    'rateExchange' : {
      'title': 'Rate exchange item',
      'type': 'number'
    },
    'gaUrl': {
      'type': 'string',
      'title': 'Link GA 5etop'
    },
    'gaPass': {
      'type': 'string',
      'title': 'Pass GA 5etop'
    },
    'enableExchangeRareItemJob': {
      'type': 'boolean',
      'title': 'Auto rút theo tên'
    },
    'bannedRollSteamIds': {
      'type': 'string',
      'title': 'Steam IDs bị ban roll'
    },
    'ezValueSecretKey': {
      'type': 'string',
      'title': 'EZValue Secret Key'
    }
  }
}

const adminSettingUISchema: UiSchema = {
  'rollWebCookie': {
    'ui:widget': 'textarea'
  },
  'rollPhoneCookie': {
    'ui:widget': 'textarea'
  },
  'emailPhone': {
    'ui:widget': 'email'
  },
  'passwordPhone': {
    'ui:widget': 'password'
  }
}

class AdminSetting extends React.Component<AdminSettingProps> {
  state: AdminState = {
    loading: true
  }

  componentDidMount() {
    this.getAdminSetting()
  }

  getAdminSetting = async () => {
    try {
      this.setState({loading: true})
      const response = await adminService.getAdminSetting()
      this.setState({
        loading: false,
        adminSetting: response
      })
    } catch (error) {
      toast.error(error.message)
    }
  }

  handleSubmitSetting = async (data: any) => {
    try {
      this.setState({loading: true})
      const response = await adminService.setAdminSetting(data.formData)
      toast.success('Set admin setting successfully!')
      this.setState({
        loading: false,
        adminSetting: response
      })
    } catch (error) {
      toast.error(error.message)
    }
  }

  onClickCookiePhone = () => {
    this.setState({
      loading: true
    })
    adminService.authPhone()
      .then(result => {
        if (result) {
          toast.success('Set cookie cho phone thành công!')
          this.setState({
            loading: false
          })
        } else {
          toast.error('Set cookie cho phone không thành công!')
          this.setState({
            loading: false
          })
        }
      })
      .catch(error => {
        toast.error('Đã có lỗi trong quá trình set cookie cho phone')
        this.setState({
          loading: false
        })
      })
  }

  onClickResetRank = () => {
    adminService.resetRank()
      .then(rs => {
        toast.success('Reset rank thành công!')
      })
      .catch(er => {
        toast.error('Reset rank không thành công! ' + er.message)
      })
  }

  render() {
    const {adminSetting, loading} = this.state
    return (
      <div>
        <Grid columns={2} stackable={true}>
          <Grid.Column>
            <Segment loading={loading}>
              <Form
                schema={adminSettingJSONSchema}
                uiSchema={adminSettingUISchema}
                formData={adminSetting}
                onSubmit={this.handleSubmitSetting}
              />
            </Segment>
          </Grid.Column>
          <Grid.Column>
            <AdminInfo/>
          </Grid.Column>
        </Grid>
        <Segment>
          <Button primary={true} onClick={this.onClickCookiePhone}>Cookie Phone</Button>
        </Segment>
        <Segment>
          <Button primary={true} onClick={this.onClickResetRank}>Reset Rank</Button>
        </Segment>
      </div>
    )
  }
}

export default AdminSetting



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/HomeRoll/modules/Admin/containers/AdminSetting.tsx